<template>
    <div>
       <h4 class="title">抵用券</h4>
       <form class="form-inline">
         <div class="form-group">
           <datepicker v-model="choosemonth" language="zh" format="yyyy-MM" placeholder="可查詢不同月份"></datepicker>
         </div>
         <div class="form-group">
           <button type="button" class="btn btn-sm btn-success" :disabled="this.searchFlag" @click="getConsume()">查詢</button>
         </div>
       </form>
       <div class="member_content">
            <table class="table table-bordered">
                <caption>

                </caption>
                <thead>
                    <tr class="success">
                        <td>店家</td>
                        <td>售價</td>
                        <td>價值</td>
                        <td>剩餘張數</td>
                        <td>時間</td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="even" role="row" v-for="(row, index) in this.redeen" >
                      <td>{{row.com_name}}</td>
                      <td>{{row.product_name}}</td>
                      <td>{{row.price}}</td>
                      <td>{{row.quota - row.redeen_times}}</td>
                      <td>{{row.created_at}}</td>
                    </tr>
                </tbody>
            </table>
      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Datepicker from 'vuejs-datepicker'

export default {
  props: ['show'],
  components: {
    Datepicker
  },
  name: 'Redeen',
  data () {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      redeen: [],
      choosemonth: '',
      detail: '',
      searchFlag: false
    }
  },
  mounted: function () {
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    getConsume () {
      // let id = this.userID
      let date = new Date(this.choosemonth)
      let queryDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2)
      // console.log(queryDate)
      this.searchFlag = true
      let token = this.$store.getters.getToken
      this.$http.get(this.memberurl + '/member_redeens', {params: {token: token, month: queryDate}}).then(function (res) {
        this.searchFlag = false
        let data = res.body.redeen
        if (data.length > 0) {
          this.redeen = data
        } else {
          window.alert('您該月份未有抵用券')
        }
      }, function () {
        console.log('failed')
      })
    }
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Redeen.vue?c4601c30